import React from "react";
import { useTheme } from "@/contexts/ThemeContext.jsx";

function toneClasses(tone = "neutral", active = false, isDark = false) {
  if (tone === "danger") {
    return {
      button: "bg-[#FF4848] shadow-[0_14px_30px_rgba(255,72,72,0.28)]",
      icon: "",
    };
  }

  if (tone === "primary") {
    return {
      button: active
        ? "bg-[rgb(var(--afrimed-primary))] shadow-[0_14px_28px_rgba(29,79,215,0.24)]"
        : isDark
          ? "bg-[rgba(249,250,251,0.12)]"
          : "bg-[#E6ECFA]",
      icon: "",
    };
  }

  return {
    button: isDark
      ? active
        ? "bg-[rgba(249,250,251,0.18)]"
        : "bg-[rgba(249,250,251,0.12)]"
      : active
        ? "bg-[#D7DFEF]"
        : "bg-[#E7ECF7]",
    icon: "",
  };
}

export default function CallControls({ items = [], showLabels = false }) {
  const { isDark } = useTheme();
  const visibleItems = (items || []).filter(Boolean);
  if (visibleItems.length === 0) return null;

  const trayClassName = isDark
    ? "rounded-[999px] border border-[rgba(249,250,251,0.08)] bg-[rgba(10,13,19,0.76)] shadow-[0_20px_60px_rgba(0,0,0,0.42)] backdrop-blur-xl"
    : "rounded-[999px] border border-[rgba(15,23,42,0.08)] bg-[rgba(255,255,255,0.92)] shadow-[0_18px_40px_rgba(15,23,42,0.08)] backdrop-blur-xl";

  return (
    <div className="pointer-events-none fixed inset-x-0 bottom-0 z-50 pb-[calc(env(safe-area-inset-bottom)+10px)]">
      <div className="mx-auto flex w-fit max-w-[calc(100vw-24px)] items-center justify-center px-3 pointer-events-auto">
        <div className={trayClassName}>
          <div className="mx-auto flex items-center justify-center gap-5 px-5 py-3 md:gap-8 md:px-6">
          {visibleItems.map((item) => {
            const tones = toneClasses(item.tone, item.active, isDark);
            return (
              <button
                key={item.key}
                type="button"
                aria-label={item.ariaLabel || item.label}
                onClick={item.onClick}
                disabled={item.disabled}
                className="flex min-w-[44px] flex-col items-center gap-2 disabled:opacity-50"
              >
                <span
                  className={[
                    "flex h-12 w-12 items-center justify-center rounded-full transition-colors",
                    tones.button,
                  ].join(" ")}
                >
                  {item.icon ? (
                    <img
                      src={item.icon}
                      alt=""
                      className={["h-6 w-6", tones.icon].join(" ")}
                      draggable="false"
                    />
                  ) : null}
                </span>
                {showLabels ? (
                  <span className="text-label-small text-on-surface-var">{item.label}</span>
                ) : null}
              </button>
            );
          })}
          </div>
        </div>
      </div>
    </div>
  );
}
